import { useEffect, useState } from "react";

import { useForm } from "../useForm";

import {
  wipStatusOptions,
  yesOrNoOptions,
  isReadOnlyUser,
} from "../../../shared/utility";
import { RECEIVING_MESSAGES } from "../../../shared/receivingInvoices";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "../../../shared/snackbar";
import ReceivingInvoiceFields from "./ReceivingInvoiceFields";
import ReceivingItemsTableComponent from "./ReceivingItemsTableComponent";
import DeleteConfirmationForm from "../DeleteConfirmationForm";
import { useNavigate } from "react-router-dom";
import ButtonDropdown from "../../controls/ButtonDropdown";
import AuditActionLink from "../../audit/AuditActionLink";
import Button from "../../controls/Button";

const initialFValues = {
  // invoice_selected: null,
  invoice_number: "",
  id: null,
  truck_selected: null,
  created_by: null,
  supplier_selected: null,
  statusSelected: wipStatusOptions[0],
  truck_question_1: null,
  truck_question_2: null,
  truck_question_3: null,
  truck_question_4: null,
  items: [],
};

export default function AddReceivingInvoiceForm(props) {
  const {
    askDeleteReceivingItemById,
    isEdit,
    truckOptions,
    fetchPosForTruck,
    productOptions,
    carrierOptions,
    supplierOptions,
    onFetchProductDetails,
    poOptions,
    setEmptyModelOpen,
    receiving,
    createReceivingInvoice,
    addItemToReceiving,
    updateReceivingItem,
    openDeleteItemByBarcodePopup,
    updateReceivingInvoice,
    employeeOptions,
    getWarehouses,
    getWarehouseLocations,
    isNewFlow,
    onDeleteReceivingInvoice,
    deleteReceivingInvoiceDocument,
    addSnackbar,
    askReturnSelectedItems,
    selectedItems,
    setSelectedItems,
    onUpdateUnitCostForReceivingItem,
    onUpdateTotalCostForReceivingItem,
    onUpdateGroupQuantities,
    printReceivingSummaryReport,
    printReceivingDetailsReport,
    closed,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    getReceivingInvoiceDetails,
  } = props;

  const isReadOnly = isReadOnlyUser();

  const buttonOptions = [
    {
      name: "Summary Report",
      onClick: printReceivingSummaryReport,
      inProgress: false,
    },
    {
      name: "Details Report",
      onClick: printReceivingDetailsReport,
      inProgress: false,
    },
  ];

  const [inProgress, setInProgress] = useState(false);
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const navigate = useNavigate();

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("invoice_selected" in fieldValues) {
      temp.invoice_selected = null;
      if (fieldValues.invoice_selected.value === -1) {
        temp.invoice_selected = "This field is required.";
      }
    }

    if ("truck_selected" in fieldValues) {
      temp.truck_selected = null;
      if (fieldValues.truck_selected) {
        if (fieldValues.truck_selected.value === -1) {
          temp.truck_selected = "This field is required.";
        }
      } else {
        temp.truck_selected = "This field is required.";
      }
    }

    if ("supplier_selected" in fieldValues) {
      temp.supplier_selected = null;
      if (fieldValues.supplier_selected) {
        if (fieldValues.supplier_selected.value === -1) {
          temp.supplier_selected = "This field is required.";
        }
      } else {
        temp.supplier_selected = "This field is required.";
      }
    }

    if ("created_by" in fieldValues) {
      temp.created_by = null;
      if (fieldValues.created_by) {
        if (fieldValues.created_by.value === -1) {
          temp.created_by = "This field is required.";
        }
      } else {
        temp.created_by = "This field is required.";
      }
    }

    if ("invoice_number" in fieldValues) {
      temp.invoice_number = null;
      if (fieldValues.invoice_number === "") {
        temp.invoice_number = "This field is required.";
      }
    }

    if ("statusSelected" in fieldValues) {
      temp.statusSelected = null;
      if (
        !fieldValues.statusSelected ||
        fieldValues.statusSelected.value === -1
      ) {
        temp.statusSelected = "This field is required.";
      }
    }

    if ("truck_question_1" in fieldValues) {
      temp.truck_question_1 = null;
      if (fieldValues.truck_question_1) {
        if (fieldValues.truck_question_1.value === -1) {
          temp.truck_question_1 = "This field is required.";
        }
      } else {
        temp.truck_question_1 = "This field is required.";
      }
    }

    if ("truck_question_2" in fieldValues) {
      temp.truck_question_2 = null;
      if (fieldValues.truck_question_2) {
        if (fieldValues.truck_question_2.value === -1) {
          temp.truck_question_2 = "This field is required.";
        }
      } else {
        temp.truck_question_2 = "This field is required.";
      }
    }

    if ("truck_question_3" in fieldValues) {
      temp.truck_question_3 = null;
      if (fieldValues.truck_question_3) {
        if (fieldValues.truck_question_3.value === -1) {
          temp.truck_question_3 = "This field is required.";
        }
      } else {
        temp.truck_question_3 = "This field is required.";
      }
    }

    if ("truck_question_4" in fieldValues) {
      temp.truck_question_4 = null;
      if (fieldValues.truck_question_4) {
        if (fieldValues.truck_question_4.value === -1) {
          temp.truck_question_4 = "This field is required.";
        }
      } else {
        temp.truck_question_4 = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate,
  );

  useEffect(() => {
    if (receiving) {
      var truckSelected = [];
      if (receiving.truck_id) {
        truckSelected = truckOptions.find(
          (el) => el.value === receiving.truck_id,
        );
      }

      var supplierSelected = [];
      if (receiving.supplier_id) {
        supplierSelected = supplierOptions.find(
          (el) => el.value === receiving.supplier_id,
        );
      }

      var carrierSelected = [];
      if (receiving.carrier_id) {
        carrierSelected = carrierOptions.find(
          (el) => el.value === receiving.carrier_id,
        );
      }

      var createdBySelected = [];
      if (receiving.created_by) {
        createdBySelected = employeeOptions.find(
          (el) => el.value === receiving.created_by,
        );
      }

      var truckQuestion1 = [];
      if (receiving.truck_question_1) {
        truckQuestion1 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_1,
        );
      }

      var truckQuestion2 = [];
      if (receiving.truck_question_2) {
        truckQuestion2 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_2,
        );
      }

      var truckQuestion3 = [];
      if (receiving.truck_question_3) {
        truckQuestion3 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_3,
        );
      }

      var truckQuestion4 = [];
      if (receiving.truck_question_4) {
        truckQuestion4 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_4,
        );
      }

      var statusSelected = wipStatusOptions.find(
        (el) => el.value === receiving.status,
      );

      setValues({
        ...values,
        ...receiving,
        truck_selected: truckSelected,
        supplier_selected: supplierSelected,
        carrier_selected: carrierSelected,
        created_by: createdBySelected,
        statusSelected: statusSelected,
        truck_question_1: truckQuestion1,
        truck_question_2: truckQuestion2,
        truck_question_3: truckQuestion3,
        truck_question_4: truckQuestion4,
      });
      console.log("useeff");
    }
  }, [receiving]);

  const handleSubmit = () => {
    if (validate()) {
      if (isEdit) {
        updateReceivingInvoice(values);
      } else {
        createReceivingInvoice(values);
      }
    }
  };

  const deleteReceivingInvoiceClicked = async function () {
    setInProgress(true);
    if (isEdit) {
      const result = await onDeleteReceivingInvoice();
      if (result.success) {
        setEmptyModelOpen({
          childComponent: null,
          open: false,
        });
        if (isNewFlow) {
          setValues(initialFValues);
        } else {
          navigate("/receiving");
        }
      }
    } else {
      if (isNewFlow) {
        setValues(initialFValues);
        showSuccessSnackbar(addSnackbar, RECEIVING_MESSAGES.restarted);
      }
    }
    setInProgress(false);
  };

  const onAskDeleteReceivingInvoice = () => {
    if (receiving.status === 1) {
      showErrorSnackbar(addSnackbar, RECEIVING_MESSAGES.closedDelete);
    } else {
      setEmptyModelOpen({
        childComponent: (
          <DeleteConfirmationForm
            buttonMessage="Delete"
            confirmAction={deleteReceivingInvoiceClicked}
            message={`Are you sure you want to ${
              isNewFlow ? "restart" : "delete"
            } receiving?`}
            setOpen={setEmptyModelOpen}
            inProgress={inProgress}
          />
        ),
        open: true,
      });
    }
  };

  return (
    <div className="justify-between">
      <div className="hide-for-print">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:flex-nowrap">
          <div className="flex items-center">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {isEdit
                ? "Editing Receiving Invoice " + values.invoice_number
                : "Add new receiving invoice"}
            </h3>
            {isEdit && values.id ? (
              <AuditActionLink
                slug="receiving-invoice"
                id={values.id}
                name={values.invoice_number}
              />
            ) : null}
          </div>
          {isReadOnly ? null : (
            <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
              {isEdit ? (
                <ButtonDropdown
                  items={buttonOptions}
                  mainOption="Save"
                  mainAction={handleSubmit}
                />
              ) : null}

              <Button
                variant="danger"
                className="w-full sm:w-auto sm:ml-2"
                onClick={onAskDeleteReceivingInvoice}
              >
                {isNewFlow ? "Restart" : "Delete Receiving"}
              </Button>
            </div>
          )}
        </div>
        <ReceivingInvoiceFields
          values={values}
          errors={errors}
          truckOptions={truckOptions}
          fetchPosForTruck={fetchPosForTruck}
          supplierOptions={supplierOptions}
          productOptions={productOptions}
          carrierOptions={carrierOptions}
          poOptions={poOptions}
          onFetchProductDetails={onFetchProductDetails}
          handleInputChange={handleInputChange}
          setEmptyModelOpen={setEmptyModelOpen}
          handleSubmit={handleSubmit}
          submitInProgress={submitInProgress}
          addItemToReceiving={addItemToReceiving}
          employeeOptions={employeeOptions}
          getWarehouses={getWarehouses}
          getWarehouseLocations={getWarehouseLocations}
          closed={closed}
          setValues={setValues}
          isEdit={isEdit}
          deleteReceivingInvoiceDocument={deleteReceivingInvoiceDocument}
        />

        {values.id > 0 ? (
          <ReceivingItemsTableComponent
            askReturnSelectedItems={askReturnSelectedItems}
            askDeleteReceivingItemById={askDeleteReceivingItemById}
            handleInputChange={handleInputChange}
            loading={false}
            values={values}
            setEmptyModelOpen={setEmptyModelOpen}
            updateReceivingItem={updateReceivingItem}
            openDeleteItemByBarcodePopup={openDeleteItemByBarcodePopup}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            onUpdateUnitCostForReceivingItem={onUpdateUnitCostForReceivingItem}
            onUpdateTotalCostForReceivingItem={
              onUpdateTotalCostForReceivingItem
            }
            onUpdateGroupQuantities={onUpdateGroupQuantities}
            closed={closed}
            loadingRows={loadingRows}
            rowDetails={rowDetails}
            fetchSubRowDetails={fetchSubRowDetails}
            subRowDetails={subRowDetails}
            subLoadingRows={subLoadingRows}
            fetchRowDetails={fetchRowDetails}
            onFetchPage={(page) => getReceivingInvoiceDetails(page)}
            rowsPerPage={values && values.items && values.items.per_page}
          />
        ) : null}
      </div>

      {/* <ReceivingBarcodeLabel barcodeDetails={barcodeDetails} /> */}
    </div>
  );
}
